<template>
<div class="config-index" :class="expand.sidebar">
    <transition :name="side" >
        <div
            v-if="expanded"
            :style="`border-${reverseSide}: 1px solid #dfdfdf`"
            class="parent"
        >
            <div class="sidebar-content">
                <slot name="header">
                    <!-- Header Slot  -->
                </slot>
                <div v-if="!$slots.header" class="list-group-item header" :style="right && 'flex-direction: row-reverse'">
                    <i
                        v-if="info"
                        type="button"
                        class="btn-tooltip mdi mdi-24px mdi-information-outline"
                        :title="$t(info)"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-animation="true"
                    />
                    <h4 class="mb-0"> {{$t(title)}} </h4>
                    <BaseButton
                        @click="expanded = !expanded"
                        class="btn-icon-only rounded-circle"
                        outline
                        type="secondary"
                    >
                        <i :class="`mdi mdi-chevron-${right ? 'right' : 'left'}`" />
                    </BaseButton>
                </div>
                <slot>
                    <!-- Default Slot -->
                </slot>
            </div>
        </div>
    </transition>
    <button
        v-if="!expanded && showToggle"
        @click="expanded = true"
        class="nch--content-toggle"
        :class="{right}"
    >
        <i :class="right ? 'mdi mdi-forum' : 'mdi mdi-menu'" />
    </button>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseButton from '../../argon/components/BaseButton';

export default {
    emits: ['input', 'update:modelValue'],
    name: 'ClassSidebar',
    components: { BaseButton },

    props: {
        icon: String,
        showToggle: Boolean,
        right: Boolean,
        modelValue: [Boolean, Number],
    },

    computed: {
        ...mapGetters({ content: 'CLASS_CONTENT' }),
        expanded: {
            get() { return this.modelValue; },
            set(value) { this.$emit('update:modelValue', value); },
        },

        reverseSide() { return !this.right ? 'right' : 'left'; },

        side() { return this.right ? 'right' : 'left'; },

        title() {
            return this.right ? 'common.chat' : 'class.course_content';
        },
        info() {
            return this.content.settings.moderate ? 'chat.moderaction_active' : null;
        },
        expand() {
            return {
                content: this.expanded ? 'nch--content-container' : 'nch--content-container-expand',
                sidebar: this.expanded ? 'sidebar-container' : 'nch--sidebar-container-expand',
            };
        },
    },
};
</script>

<style lang="sass" scoped>
.left-enter-active, .left-leave-active, .right-enter-active, .right-leave-active
  transition: all .5s cubic-bezier(0, 0.55, 0.45, 1)

.left-enter
  transform: translateX(-300px)

.left-enter-to, .right-enter-to
  transform: translateX(0)

.left-leave-to
  transform: translateX(-300px)


.right-leave-to
  transform: translateX(+300px)


.right-enter
  transform: translateX(+300px)

.sidebar-content
    height: 100%
    width: 100%
    display: flex
    flex-direction: column
    flex-grow: 1
    border-right: 3px solid #5E72E4
    background-color: #fff


.sidebar-content::-webkit-scrollbar
  width: 8px

  @media (max-width: 1200px)
    display: none

.sidebar-content::-webkit-scrollbar-track
  background-color: #f1f1f1


.sidebar-content::-webkit-scrollbar-thumb
  background-color: #5E72E4
  border-radius: 25px

.sidebar-content::-webkit-scrollbar-thumb:hover
  background-color: #555

.sidebar-container
    width: 35%

.list-group-item
    border: none
    border-radius: 0
    display: flex
    justify-content: space-between
    align-items: center


.config-index
    z-index: 70

.rounded-circle
    width: 3rem !important
    height: 3rem !important

.mdi-chevron-left, .mdi-chevron-right
    transform: scale(1.8)
    color: black


.nch--content-toggle
    position: fixed
    background-color: rgba(255, 255, 255, 0.7) !important
    border: none
    border-radius: 0 50px 50px 0
    pointer-events: auto
    height: 40px
    width: 40px
    left: 0
    top: 270px
    z-index: 999
    -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)
    transition: all .2s ease-in-out
    &:hover
        width: 50px
        background-color: rgba(255, 255, 255, 1) !important

    &.right
        left: unset
        border-radius: 50px 0 0 50px
        right: 0
    i
        font-size: 1.5rem
        color: #707070

.parent
    height: 100%
    border-bottom: 2px solid #dfdfdf
</style>
